'use strict';
/**
 *  Load modules
 */

import login from './modules/login.js';
import filter from './modules/filter.js';
import sliders from './modules/sliders.js';
import header from './modules/sticky-header.js';
import sortable from './modules/sortable.js';

require('./modules/review.js');

import '../scss/app.scss';
$(document).ready(function () {
  login();
  filter();
  sliders();
  header();
  sortable();
});